<section class="content">
  <div class="container">
    <div class="row">
      <div class="col-2">
        <mat-label>Select Booth Types</mat-label>
        <mat-select [(ngModel)]="selected_booth_type_list" multiple class="main-border-class">
          <mat-option *ngFor="let booth of booth_types" [value]="booth.value">{{booth.display_name}}</mat-option>
        </mat-select>
      </div>
      <div class="col-2">
        <mat-label>Report Type</mat-label>
        <mat-select [(ngModel)]="selected_inp_type" class="main-border-class">
          <mat-option default value="Month">Month Wise</mat-option>
          <mat-option default value="Date Range">Date Wise</mat-option>
        </mat-select>
      </div>
      <div class="col-2">
        <mat-label>Select Shift</mat-label>
        <mat-select [(ngModel)]="selected_session" class="main-border-class">
          <mat-option [value]="shift.id" *ngFor="let shift of session_list">{{shift['name']}} </mat-option>
          <mat-option default value="all">Both Shifts</mat-option>
        </mat-select>
      </div>
      <div class="col-2" *ngIf="selected_inp_type == 'Month'">
        <mat-label>Select Year</mat-label>
        <mat-select [(ngModel)]="selected_year" class="main-border-class">
          <mat-option *ngFor="let year of inp_years" [value]="year">{{year}}</mat-option>
        </mat-select>
      </div>
      <div class="col-3" *ngIf="selected_inp_type == 'Month'">
        <mat-label>Select Months</mat-label>
        <mat-select [(ngModel)]="selected_month" multiple class="main-border-class">
          <mat-option *ngFor="let month of monthNames" [value]="month">{{month}}</mat-option>
        </mat-select>
      </div>

      <div class="col-3" *ngIf="selected_inp_type == 'Date Range'">
        <mat-label style="color: firebrick;">From Date</mat-label>
        <input type="date" [(ngModel)]="selected_from_date" class="main-border-class">
      </div>

      <div class="col-3" *ngIf="selected_inp_type == 'Date Range'" style="padding-left: 35px;">
        <mat-label style="color: firebrick;">To Date</mat-label>
        <input type="date" [(ngModel)]="selected_to_date" [min]="selected_from_date" class="main-border-class">
      </div>

      <div class="col-2" *ngIf="selected_inp_type == 'Month'">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 14%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="selected_inp_type == null || selected_year == null || selected_session == null">Get</button>
      </div>

      <div class="col-2" style="padding-left: 35px;" *ngIf="selected_inp_type == 'Date Range'">
        <button (click)="getClicked()"
          style="font-size: 27px; margin-top: 14%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="selected_inp_type == null || selected_from_date == null || selected_to_date == null || selected_session == null">Get</button>
      </div>
    </div>
    <br><br><br><br>
    <div *ngIf="!is_document_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div class="row" *ngIf="document_file !== null">
      <div class="col-6"></div>
      <div class="col-6">
        <div class="row">
          <div class="col-4">
          </div>
          <div class="col-4">
            <button mat-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
                picture_as_pdf
              </i> Download Excel </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
